module.exports = __webpack_public_path__ + "static/media/86b76db5-9343-473a-a106-60683cec7626.a038ce4d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/86b76db5-9343-473a-a106-60683cec7626.woff
// module id = 95
// module chunks = 0